import { z } from "zod";

export const authenticationMethodSchema = z.object({
	id: z.number(),
	name: z.string(),
});

export type AuthenticationMethod = z.infer<typeof authenticationMethodSchema>;
